import PremiumDomainsPage from '../components/PremiumDomainsPage'
export default PremiumDomainsPage